import type { CategoryType } from "@/components/game-categories";
import type { PaginationType } from "@/components/pagination";

export interface CompanyType {
  id: string;
  name: string;
}

export interface GameType {
  gameimageSet: {
    id: string;
    imageId: string;
  }[];
  id: string;
  location: {
    id: string;
    company: CompanyType;
    displayName?: string;
  };
  name: string;
  primaryCategory?: CategoryType;
  slug?: string;
}

interface ExperiencesCountFacetsType {
  category: {
    slug: string;
  };
  count: number;
}

export interface UserType {
  escapedCount?: number;
  experiencesCountFacets?: ExperiencesCountFacetsType[];
  id: string;
  imageId?: string;
  username: string;
}

export const ReviewComponentTypeEnum = {
  OPTIONS: "OPTIONS",
  RATING: "RATING",
  TEXT: "TEXT",
} as const;
export type ReviewComponentTypeEnum =
  (typeof ReviewComponentTypeEnum)[keyof typeof ReviewComponentTypeEnum];

export interface ReviewComponentType {
  id: string;
  options: {
    id: string;
    value: string;
  }[];
  question: string;
  response: {
    comment?: string;
    optionId?: string;
  };
  shortQuestion?: string;
  type: ReviewComponentTypeEnum;
}

export interface OperatorResponseType {
  body: string;
  createdAt: string;
  user: UserType;
}

export interface ReviewImageType {
  id: string;
  imageId?: string;
}

export interface ReviewType {
  components: ReviewComponentType[];
  createdAt: string;
  escape: {
    id: string;
    game?:
      | {
          id: string;
        }
      | GameType;
    gameDate?: string;
  };
  id: string;
  images?: ReviewImageType[];
  isContainingSpoilers: boolean;
  operatorResponse?: OperatorResponseType;
  overallRating?: string;
  summary?: string;
  user: UserType;
}

export const SortByOptions = {
  DATE_PLAYED: "DATE_PLAYED",
  // RELEVANCE: 'RELEVANCE',
  DATE_REVIEWED: "DATE_REVIEWED",
  SCORE: "SCORE",
} as const;

export type SortByType = keyof typeof SortByOptions;

export type ReviewsPaginationType = PaginationType<ReviewType>;
